var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsNotificationsV2NotificationConfig from '@wix/ambassador-events-notifications-v2-notification-config/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var EmailNotificationType;
(function (EmailNotificationType) {
    /** Default value. This value is unused. */
    EmailNotificationType["UNKNOWN_NOTIFICATION_TYPE"] = "UNKNOWN_NOTIFICATION_TYPE";
    /** Triggered when site user RSVP to the event. */
    EmailNotificationType["EMAIL_RSVP_CONFIRMATION"] = "EMAIL_RSVP_CONFIRMATION";
    /** Triggered for waiting guests when additional RSVP spots appears in the fully booked event. */
    EmailNotificationType["EMAIL_NEW_SPOTS_AVAILABLE"] = "EMAIL_NEW_SPOTS_AVAILABLE";
    /** Triggered when event is canceled. */
    EmailNotificationType["EMAIL_EVENT_CANCELATION"] = "EMAIL_EVENT_CANCELATION";
    /** Triggered before the event start time. */
    EmailNotificationType["EMAIL_UPCOMING_EVENT_REMINDER"] = "EMAIL_UPCOMING_EVENT_REMINDER";
    /** Triggered when site user creates Order. */
    EmailNotificationType["EMAIL_ORDER_CONFIRMATION"] = "EMAIL_ORDER_CONFIRMATION";
    /** Triggered when resending ticket to ticket holder. */
    EmailNotificationType["EMAIL_TICKET_CONFIRMATION"] = "EMAIL_TICKET_CONFIRMATION";
    /** Triggered when sending invoice. Currently only `enabled` flag update is supported. */
    EmailNotificationType["EMAIL_INVOICE"] = "EMAIL_INVOICE";
    /** Triggered when order confirmation sending is delayed. Tickets are accessible via link. */
    EmailNotificationType["EMAIL_ORDER_CONFIRMATION_WITH_TICKETS_LINK"] = "EMAIL_ORDER_CONFIRMATION_WITH_TICKETS_LINK";
})(EmailNotificationType || (EmailNotificationType = {}));
export var EmailNotificationReminderTime;
(function (EmailNotificationReminderTime) {
    /** Default value. This value is unused. */
    EmailNotificationReminderTime["UNKNOWN_REMINDER_TIME"] = "UNKNOWN_REMINDER_TIME";
    /** Notification is sent instantly */
    EmailNotificationReminderTime["INSTANT"] = "INSTANT";
    /** 24 hours prior */
    EmailNotificationReminderTime["BEFORE_1_DAY"] = "BEFORE_1_DAY";
    /** 3 days prior */
    EmailNotificationReminderTime["BEFORE_3_DAYS"] = "BEFORE_3_DAYS";
    /** 7 days prior */
    EmailNotificationReminderTime["BEFORE_1_WEEK"] = "BEFORE_1_WEEK";
    /** 1 hour prior */
    EmailNotificationReminderTime["BEFORE_1_HOUR"] = "BEFORE_1_HOUR";
    /** 30 minutes prior */
    EmailNotificationReminderTime["BEFORE_30_MINUTES"] = "BEFORE_30_MINUTES";
})(EmailNotificationReminderTime || (EmailNotificationReminderTime = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var AttendanceStatus;
(function (AttendanceStatus) {
    /** Not attending. */
    AttendanceStatus["NOT_ATTENDING"] = "NOT_ATTENDING";
    /** Attending. */
    AttendanceStatus["ATTENDING"] = "ATTENDING";
    /** In a waiting list. */
    AttendanceStatus["IN_WAITLIST"] = "IN_WAITLIST";
})(AttendanceStatus || (AttendanceStatus = {}));
export var GuestType;
(function (GuestType) {
    /** Rsvp guest. */
    GuestType["RSVP"] = "RSVP";
    /** Buyer guest. */
    GuestType["BUYER"] = "BUYER";
    /** Ticket holder guest. */
    GuestType["TICKET_HOLDER"] = "TICKET_HOLDER";
})(GuestType || (GuestType = {}));
export var MemberEventStatusUpdatedEventType;
(function (MemberEventStatusUpdatedEventType) {
    /**
     * Every time a guest with specified member ID is added to the event.
     * This event can also be fired if existing guest changed member ID.
     */
    MemberEventStatusUpdatedEventType["MEMBER_JOINED"] = "MEMBER_JOINED";
    /**
     * Every time a guest with specified member ID is removed from the event.
     * This event can also be fired if existing guest changed member ID.
     */
    MemberEventStatusUpdatedEventType["MEMBER_LEFT"] = "MEMBER_LEFT";
    /**
     * Every time a guest with specified member ID and status ATTENDING is added to the event.
     * This event can also be fired if existing guest changed member ID or status to ATTENDING.
     */
    MemberEventStatusUpdatedEventType["ATTENDING_MEMBER_JOINED"] = "ATTENDING_MEMBER_JOINED";
    /**
     * Once last guest with specified member ID is removed from the event or status became not ATTENDING.
     * Once this is fired there are no more attending guests with specified member ID in the event.
     * This event can also be fired if existing guest changed their member ID or status to not ATTENDING.
     */
    MemberEventStatusUpdatedEventType["LAST_ATTENDING_MEMBER_LEFT"] = "LAST_ATTENDING_MEMBER_LEFT";
})(MemberEventStatusUpdatedEventType || (MemberEventStatusUpdatedEventType = {}));
export var ContactEventStatusUpdatedEventType;
(function (ContactEventStatusUpdatedEventType) {
    /**
     * Every time a guest with specified contact ID is added to the event.
     * This event can also be fired if existing guest changed contact ID.
     */
    ContactEventStatusUpdatedEventType["CONTACT_JOINED"] = "CONTACT_JOINED";
    /**
     * Every time a guest with specified contact ID is removed from the event.
     * This event can also be fired if existing guest changed contact ID.
     */
    ContactEventStatusUpdatedEventType["CONTACT_LEFT"] = "CONTACT_LEFT";
    /**
     * Once last guest with specified contact ID is removed from the event.
     * Once this is fired there are no more guests with specified contact ID in the event.
     * This event can also be fired if existing guest changed their contact ID.
     */
    ContactEventStatusUpdatedEventType["LAST_CONTACT_LEFT"] = "LAST_CONTACT_LEFT";
})(ContactEventStatusUpdatedEventType || (ContactEventStatusUpdatedEventType = {}));
export var NotifyActionType;
(function (NotifyActionType) {
    NotifyActionType["UNKNOWN"] = "UNKNOWN";
    NotifyActionType["EMAIL"] = "EMAIL";
    NotifyActionType["AUTOMATION_TRIGGER"] = "AUTOMATION_TRIGGER";
    NotifyActionType["PUSH"] = "PUSH";
})(NotifyActionType || (NotifyActionType = {}));
export var TargetType;
(function (TargetType) {
    TargetType["NONE"] = "NONE";
    TargetType["WIX_PROTO_BUNDLE_EXPORT"] = "WIX_PROTO_BUNDLE_EXPORT";
    TargetType["WIX_APPENDIX_BUNDLE_EXPORT"] = "WIX_APPENDIX_BUNDLE_EXPORT";
    TargetType["WIX_API_REGISTRY_INFO_EXPORT"] = "WIX_API_REGISTRY_INFO_EXPORT";
})(TargetType || (TargetType = {}));
export var PushNotificationType;
(function (PushNotificationType) {
    /** This is default value. This value is unused. */
    PushNotificationType["UNKNOWN_PUSH_TYPE"] = "UNKNOWN_PUSH_TYPE";
    /** Triggered when event is updated. */
    PushNotificationType["PUSH_EVENT_UPDATED"] = "PUSH_EVENT_UPDATED";
    /** Triggered when event is canceled. */
    PushNotificationType["PUSH_EVENT_CANCELATION"] = "PUSH_EVENT_CANCELATION";
    /** Triggered before the event start time. */
    PushNotificationType["PUSH_UPCOMING_EVENT_REMINDER"] = "PUSH_UPCOMING_EVENT_REMINDER";
    /** Triggered when event is created. */
    PushNotificationType["PUSH_EVENT_CREATED"] = "PUSH_EVENT_CREATED";
})(PushNotificationType || (PushNotificationType = {}));
export var RsvpStatus;
(function (RsvpStatus) {
    RsvpStatus["YES"] = "YES";
    RsvpStatus["NO"] = "NO";
    RsvpStatus["WAITING"] = "WAITING";
})(RsvpStatus || (RsvpStatus = {}));
export var LocationType;
(function (LocationType) {
    LocationType["VENUE"] = "VENUE";
    LocationType["ONLINE"] = "ONLINE";
})(LocationType || (LocationType = {}));
export var Status;
(function (Status) {
    /** Event occurs only once. */
    Status["ONE_TIME"] = "ONE_TIME";
    /** Event is recurring. */
    Status["RECURRING"] = "RECURRING";
    /** Marks the next upcoming occurrence of the recurring event. */
    Status["RECURRING_NEXT"] = "RECURRING_NEXT";
    /** Marks the most recent ended occurrence of the recurring event. */
    Status["RECURRING_LAST_ENDED"] = "RECURRING_LAST_ENDED";
    /** Marks the most recent canceled occurrence of the recurring event. */
    Status["RECURRING_LAST_CANCELED"] = "RECURRING_LAST_CANCELED";
})(Status || (Status = {}));
export var EventStatus;
(function (EventStatus) {
    /** Event is public and scheduled to start */
    EventStatus["SCHEDULED"] = "SCHEDULED";
    /** Event has started */
    EventStatus["STARTED"] = "STARTED";
    /** Event has ended */
    EventStatus["ENDED"] = "ENDED";
    /** Event was canceled */
    EventStatus["CANCELED"] = "CANCELED";
    /** Event is not public and needs to be published */
    EventStatus["DRAFT"] = "DRAFT";
})(EventStatus || (EventStatus = {}));
export var EventType;
(function (EventType) {
    /** Type not available for this request fieldset */
    EventType["NA_EVENT_TYPE"] = "NA_EVENT_TYPE";
    /** Registration via RSVP */
    EventType["RSVP"] = "RSVP";
    /** Registration via ticket purchase */
    EventType["TICKETS"] = "TICKETS";
    /** External registration */
    EventType["EXTERNAL"] = "EXTERNAL";
    /** Registration not available */
    EventType["NO_REGISTRATION"] = "NO_REGISTRATION";
})(EventType || (EventType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    /** Registration status is not applicable */
    RegistrationStatus["NA_REGISTRATION_STATUS"] = "NA_REGISTRATION_STATUS";
    /** Registration to event is closed */
    RegistrationStatus["CLOSED"] = "CLOSED";
    /** Registration to event is closed manually */
    RegistrationStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Registration is open via RSVP */
    RegistrationStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Registration to event waitlist is open via RSVP */
    RegistrationStatus["OPEN_RSVP_WAITLIST"] = "OPEN_RSVP_WAITLIST";
    /** Registration is open via ticket purchase */
    RegistrationStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Registration is open via external URL */
    RegistrationStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration will be open via RSVP */
    RegistrationStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    /** Only YES RSVP status is available for RSVP registration */
    RsvpStatusOptions["YES_ONLY"] = "YES_ONLY";
    /** YES and NO RSVP status options are available for the registration */
    RsvpStatusOptions["YES_AND_NO"] = "YES_AND_NO";
})(RsvpStatusOptions || (RsvpStatusOptions = {}));
export var TaxType;
(function (TaxType) {
    /** Tax is included in the ticket price */
    TaxType["INCLUDED"] = "INCLUDED";
    /** Tax is added to the order at the checkout */
    TaxType["ADDED"] = "ADDED";
    /** Tax is added to the final total at the checkout */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var VisitorType;
(function (VisitorType) {
    /** Site visitor (including member) */
    VisitorType["VISITOR"] = "VISITOR";
    /** Site member */
    VisitorType["MEMBER"] = "MEMBER";
    /** Site visitor or member */
    VisitorType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
})(VisitorType || (VisitorType = {}));
export var InputControlType;
(function (InputControlType) {
    /** Single text value field. */
    InputControlType["INPUT"] = "INPUT";
    /** Single text value field. */
    InputControlType["TEXTAREA"] = "TEXTAREA";
    /** Single-choice field of predefined values. */
    InputControlType["DROPDOWN"] = "DROPDOWN";
    /** Single-choice field of predefined values. */
    InputControlType["RADIO"] = "RADIO";
    /** Multiple-choice field of predefined values. */
    InputControlType["CHECKBOX"] = "CHECKBOX";
    /** First and last name fields. */
    InputControlType["NAME"] = "NAME";
    /** Additional guests and respective guest names fields. */
    InputControlType["GUEST_CONTROL"] = "GUEST_CONTROL";
    /** Single-line address field. */
    InputControlType["ADDRESS_SHORT"] = "ADDRESS_SHORT";
    /** Full address field. */
    InputControlType["ADDRESS_FULL"] = "ADDRESS_FULL";
    /** Year, month and day fields. */
    InputControlType["DATE"] = "DATE";
})(InputControlType || (InputControlType = {}));
export var ValueType;
(function (ValueType) {
    ValueType["TEXT"] = "TEXT";
    ValueType["NUMBER"] = "NUMBER";
    ValueType["TEXT_ARRAY"] = "TEXT_ARRAY";
    ValueType["DATE_TIME"] = "DATE_TIME";
    ValueType["ADDRESS"] = "ADDRESS";
})(ValueType || (ValueType = {}));
export var ConferenceType;
(function (ConferenceType) {
    /** Everyone in the meeting can publish and subscribe video and audio. */
    ConferenceType["MEETING"] = "MEETING";
    /** Guests can only subscribe to video and audio. */
    ConferenceType["WEBINAR"] = "WEBINAR";
})(ConferenceType || (ConferenceType = {}));
export var State;
(function (State) {
    /** Created manually by the user. */
    State["MANUAL"] = "MANUAL";
    /** Created automatically. */
    State["AUTO"] = "AUTO";
    /** Created when publishing recurring events. */
    State["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Category is hidden. */
    State["HIDDEN"] = "HIDDEN";
    /** Category is used to store component events. */
    State["COMPONENT"] = "COMPONENT";
})(State || (State = {}));
export var OrderStatus;
(function (OrderStatus) {
    /** Order status not available for this request fieldset */
    OrderStatus["NA_ORDER_STATUS"] = "NA_ORDER_STATUS";
    /** Order is confirmed, no payment required */
    OrderStatus["FREE"] = "FREE";
    /** Order was paid but payment gateway suspended the payment. Eventually changes to PAID */
    OrderStatus["PENDING"] = "PENDING";
    /** Order paid via payment gateway */
    OrderStatus["PAID"] = "PAID";
    /** Order confirmed but has to be paid via offline payment and status manually updated to PAID */
    OrderStatus["OFFLINE_PENDING"] = "OFFLINE_PENDING";
    /** Order is awaiting for payment in Cashier */
    OrderStatus["INITIATED"] = "INITIATED";
    /** Order was canceled */
    OrderStatus["CANCELED"] = "CANCELED";
    /** Order payment was declined */
    OrderStatus["DECLINED"] = "DECLINED";
})(OrderStatus || (OrderStatus = {}));
export var FeeName;
(function (FeeName) {
    /** Wix service fee charges applied to the line item. */
    FeeName["WIX_FEE"] = "WIX_FEE";
})(FeeName || (FeeName = {}));
export var FeeType;
(function (FeeType) {
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED"] = "FEE_ADDED";
    /** Seller absorbs the fee. It is deducted from the ticket price */
    FeeType["FEE_INCLUDED"] = "FEE_INCLUDED";
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED_AT_CHECKOUT"] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType || (FeeType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _resolveNotificationConfigRequest = {};
const _resolveNotificationConfigResponse = {};
const _triggerNotificationRequest = {};
const _triggerNotificationResponse = {};
const _upsertNotificationConfigRequest = {};
const _upsertNotificationConfigResponse = {};
/**
 * Triggers notification
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function triggerNotification(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            emailNotificationType: '$[0].emailNotificationType',
            pushNotificationType: '$[0].pushNotificationType',
            rsvpGuest: '$[0].rsvpGuest',
            orderGuest: '$[0].orderGuest',
            eventGuests: '$[0].eventGuests',
            ticketGuest: '$[0].ticketGuest',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _triggerNotificationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _triggerNotificationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsNotificationsV2NotificationConfig.triggerNotification(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Resolves a NotificationConfig by id. Returns saved value or default value if not saved yet.
 * @param notificationConfigId - Id of the NotificationConfig to retrieve
 * @public
 * @documentationMaturity preview
 * @requiredField notificationConfigId
 * @adminMethod
 */
export function resolveNotificationConfig(notificationConfigId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { notificationConfigId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _resolveNotificationConfigRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _resolveNotificationConfigResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['notificationConfig']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([notificationConfigId]);
        const reqOpts = ambassadorWixEventsNotificationsV2NotificationConfig.resolveNotificationConfig(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'notificationConfigId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Upsert a NotificationConfig
 * @param _id - Event ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField notificationConfig
 * @adminMethod
 */
export function upsertNotificationConfig(_id, notificationConfig, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            notificationConfig: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _upsertNotificationConfigRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['notificationConfig']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _upsertNotificationConfigResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['notificationConfig']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, notificationConfig, options]);
        const reqOpts = ambassadorWixEventsNotificationsV2NotificationConfig.upsertNotificationConfig(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'notificationConfig',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-notifications-v2-notification-config.universal.js.map